import { message } from 'antd';

export const handleAxiosError = (error, customFallbackMessage = 'An unexpected error occurred.') => {
  console.error('API Error:', error);

  let errorMessage = customFallbackMessage;

  if (error.response) {
    const statusCode = error.response.status;
    const backendMessage = error.response.data?.message;

    if (backendMessage) {
      errorMessage = backendMessage;
    } else if (statusCode) {
      errorMessage = `${statusCode} error occurred while fetching data.`;
    }
  } else if (error.request) {
    errorMessage = 'No response from server. Please check your network connection.';
  } else if (error.message) {
    errorMessage = error.message;
  }

  message.error(errorMessage);
};
